import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'
import type { PropsWithChildren } from 'react'
import { createScope } from '~/lib/jotai'

const scope = createScope('applied')
const _useApplied$ = scope.atom(false)
export const useApplied$ = atom((get) => get(_useApplied$))
export const useDraft$ = atom((get) => !get(useApplied$))

export function useApplied() {
  return useAtomValue(useApplied$)
}

export function useDraft() {
  return useAtomValue(useDraft$)
}

/**
 * facet を利用するとき適用中の条件によるファセットを利用する状態にする
 * SwitchFacetProvider 下で draft を利用したいときは useDraft を true にした SwitchFacetProvider を利用する
 */
export function SwitchFacetProvider(props: PropsWithChildren<{ useDraft?: boolean }>) {
  return (
    <scope.Provider>
      <Init useDraft={props.useDraft} />
      {props.children}
    </scope.Provider>
  )
}

function Init(props: { useDraft?: boolean }) {
  const setApplied = useSetAtom(_useApplied$)
  useEffect(() => {
    setApplied(!props.useDraft)
  }, [setApplied, props.useDraft])
  return null
}
